import { render, staticRenderFns } from "./Repetirdia.vue?vue&type=template&id=29dbe79a&scoped=true&"
import script from "./Repetirdia.vue?vue&type=script&lang=ts&"
export * from "./Repetirdia.vue?vue&type=script&lang=ts&"
import style0 from "./Repetirdia.vue?vue&type=style&index=0&id=29dbe79a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dbe79a",
  null
  
)

export default component.exports